// BUG-629: página que canjea el enlace de un solo uso que ahora llega por
// correo (alta de usuario, reseteo por CEO, activación de portal broker) en
// vez de la contraseña en texto plano. Público — el token trae la identidad.
import React, { useState } from 'react';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import { Building2, Lock, ArrowRight, AlertCircle, CheckCircle2 } from 'lucide-react';

import { authApi } from '@api/client';
import { Input } from '@components/ui/Input';
import { Button } from '@components/ui/Button';
import { useTema } from '@components/M02/casaTema';

import { extractApiError } from '@utils/apiError';
const EstablecerPassword: React.FC = () => {
  const T = useTema();
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmacion, setConfirmacion] = useState('');
  const [error, setError] = useState('');
  const [listo, setListo] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres');
      return;
    }
    if (password !== confirmacion) {
      setError('Las contraseñas no coinciden');
      return;
    }

    setSubmitting(true);
    try {
      await authApi.establecerPassword(token, password);
      setListo(true);
      setTimeout(() => navigate('/login', { replace: true }), 2500);
    } catch (err: unknown) {
      setError(extractApiError(err, 'El enlace es inválido o ya expiró.'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center p-8" style={{ backgroundColor: T.panelSoft }}>
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8 justify-center">
          <div
            className="flex items-center justify-center rounded-lg"
            style={{ width: '36px', height: '36px', backgroundColor: T.estados.cfo }}
          >
            <Building2 size={20} color={T.panelSolid} />
          </div>
          <span className="font-bold text-lg" style={{ color: T.fg }}>RM ERP</span>
        </div>

        {listo ? (
          <div
            className="flex flex-col items-center gap-3 text-center rounded-xl p-6"
            style={{ backgroundColor: T.accentSoft, border: `1px solid ${T.accentLine}` }}
          >
            <CheckCircle2 size={32} color="#166534" />
            <p className="text-sm font-semibold" style={{ color: '#166534' }}>
              Contraseña establecida. Ya puedes iniciar sesión.
            </p>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-bold mb-1 text-center" style={{ color: T.fg, letterSpacing: '-0.02em' }}>
              Establece tu contraseña
            </h1>
            <p className="text-sm mb-8 text-center" style={{ color: T.fg3 }}>
              Este enlace es de un solo uso y expira en 24 horas.
            </p>

            <form onSubmit={handleSubmit} className="space-y-4" noValidate>
              <Input
                label="Nueva contraseña"
                type="password"
                placeholder="Mínimo 8 caracteres"
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(''); }}
                icon={<Lock size={15} />}
                required
                autoComplete="new-password"
                autoFocus
              />
              <Input
                label="Confirma tu contraseña"
                type="password"
                placeholder="Repite la contraseña"
                value={confirmacion}
                onChange={(e) => { setConfirmacion(e.target.value); setError(''); }}
                icon={<Lock size={15} />}
                required
                autoComplete="new-password"
              />

              {error && (
                <div
                  className="flex items-start gap-2 rounded-lg px-3 py-2.5 text-sm"
                  style={{ backgroundColor: T.dangerSoft, border: `1px solid ${T.dangerLine}`, color: T.danger }}
                >
                  <AlertCircle size={15} className="flex-shrink-0 mt-0.5" />
                  <span>{error}</span>
                </div>
              )}

              <Button
                type="submit"
                variant="primary"
                size="lg"
                fullWidth
                loading={submitting}
                icon={<ArrowRight size={16} />}
                iconPosition="right"
              >
                Establecer contraseña
              </Button>
            </form>

            <p className="mt-6 text-xs text-center" style={{ color: T.fg3 }}>
              <Link to="/login" style={{ color: T.estados.cfo }}>Volver a iniciar sesión</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default EstablecerPassword;
